
import moment from 'moment';

var maskInputs = function () {
    
    var phone = function() {
        let phones = document.querySelectorAll(".phone");
        for (var i = 0; i < phones.length; i++) {
            IMask(phones[i], {
                mask: [
                    {
                    mask:'(00) 0000-0000',
                    },
                    {
                    mask:'(00) 00000-0000',
                    },
                ],
            });
        }
    }


    var birthday = function() {
        let birthdays = document.querySelectorAll(".birthday");
        for (var i = 0; i < birthdays.length; i++) {
            IMask(birthdays[i], {
                mask: [
                    {
                    mask:'00/00/0000',
                    },
                ],
            });
        }
    }

    var birthdayEvent = function() {
        let momentFormat = 'DD/MM/YYYY';
        let birthdays = document.querySelectorAll(".birthdayEvent");
        for (var i = 0; i < birthdays.length; i++) {
            IMask(birthdays[i], {
                mask: Date,
                pattern: momentFormat,
                el: birthdays[i],
                blocks: {
                    YYYY: {
                        mask: IMask.MaskedRange,
                        from: 1923,
                        to: 2030
                    },
                    MM: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 12
                    },
                    DD: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 31
                    }
                },
                format: function (date) {
                  
                    
                    if(moment().diff(date, 'years',false)<18){
                        if(this.el.parentElement.parentElement.querySelector('input[type="checkbox"]')){
                            this.el.parentElement.parentElement.querySelector('input[type="checkbox"]').disabled=false;
                        }
                    }else{
                        if(this.el.parentElement.parentElement.querySelector('input[type="checkbox"]')){
                            this.el.parentElement.parentElement.querySelector('input[type="checkbox"]').disabled=true;
                        }
                    }
                    return moment(date).format(momentFormat);
                },
                parse: function (str) {
                    return moment(str, momentFormat);
                },
                min: new Date(1900, 0, 1),  
                max: new Date()
            }).on("complete",function(e){
            });
        }
    }
   

    var cpf = function() {
        let cpfs = document.querySelectorAll(".cpf");
        for (var i = 0; i < cpfs.length; i++) {
            IMask(cpfs[i], {
                mask: [
                    {
                    mask:'000.000.000-00',
                    },
                ],
            });
        }
    }

    var cep = function() {
        let ceps = document.querySelectorAll(".cep");
        for (var i = 0; i < ceps.length; i++) {
            IMask(ceps[i], {
                mask: [
                    {
                    mask:'00000-000',
                    },
                ],
            });
        }
    }

    //^(?!0\.00)[1-9]\d{0,2}(,\d{3})*(\.\d\d)?$
    var currencyMask = function(){

        let prices = document.querySelectorAll(".price");
        for (var i = 0; i < prices.length; i++) {
            window.currencyMask(prices[i]);
            
        }

    }

    var percentMask = function(){

        let percents = document.querySelectorAll(".percent");
        for (var i = 0; i < percents.length; i++) {
            window.percentMask(percents[i]);
        }

    }

    var expirationDate = function() {
        let momentFormat = 'MM/YYYY';
        let expirationDates = document.querySelectorAll(".expirationDate");
        for (var i = 0; i < expirationDates.length; i++) {
            IMask(expirationDates[i], {
                mask: Date,
                pattern: momentFormat,
                el: expirationDates[i],
                blocks: {
                    YYYY: {
                        mask: IMask.MaskedRange,
                        from: 1999,
                        to: 2100
                    },
                    MM: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 12
                    }
                },
                format: function (date) {
                  
                    return moment(date).format(momentFormat);
                },
                parse: function (str) {
                    return moment(str, momentFormat);
                },  
            }).on("complete",function(e){
            });
        }
    }

    var securityCode = function() {
        let securityCodes = document.querySelectorAll(".securityCode");
        for (var i = 0; i < securityCodes.length; i++) {
            IMask(securityCodes[i], {
                mask: [
                    {
                    mask:'000',
                    },
                    {
                    mask:'0000',
                    },
                ],
            });
        }
    }

    var numberCard = function() {
        let numberCards = document.querySelectorAll(".numberCard");
        for (var i = 0; i < numberCards.length; i++) {
            IMask(numberCards[i], {
                mask: [
                    {
                        mask: '0000 000000 00000',
                        regex: '^3[47]\\d{0,13}',
                        cardtype: 'american express'
                    },
                    {
                        mask: '0000 0000 0000 0000',
                        regex: '^(?:6011|65\\d{0,2}|64[4-9]\\d?)\\d{0,12}',
                        cardtype: 'discover'
                    },
                    {
                        mask: '0000 000000 0000',
                        regex: '^3(?:0([0-5]|9)|[689]\\d?)\\d{0,11}',
                        cardtype: 'diners'
                    },
                    {
                        mask: '0000 0000 0000 0000',
                        regex: '^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}',
                        cardtype: 'mastercard'
                    },
                    // {
                    //     mask: '0000-0000-0000-0000',
                    //     regex: '^(5019|4175|4571)\\d{0,12}',
                    //     cardtype: 'dankort'
                    // },
                    // {
                    //     mask: '0000-0000-0000-0000',
                    //     regex: '^63[7-9]\\d{0,13}',
                    //     cardtype: 'instapayment'
                    // },
                    {
                        mask: '0000 000000 00000',
                        regex: '^(?:2131|1800)\\d{0,11}',
                        cardtype: 'jcb15'
                    },
                    {
                        mask: '0000 0000 0000 0000',
                        regex: '^(?:35\\d{0,2})\\d{0,12}',
                        cardtype: 'jcb'
                    },
                    {
                        mask: '0000 0000 0000 0000',
                        regex: '^(?:5[0678]\\d{0,2}|6304|67\\d{0,2})\\d{0,12}',
                        cardtype: 'maestro'
                    },
                    // {
                    //     mask: '0000-0000-0000-0000',
                    //     regex: '^220[0-4]\\d{0,12}',
                    //     cardtype: 'mir'
                    // },
                    {
                        mask: '0000 0000 0000 0000',
                        regex: '^4\\d{0,15}',
                        cardtype: 'visa'
                    },
                    {
                        mask: '0000 0000 0000 0000',
                        regex: '^62\\d{0,14}',
                        cardtype: 'unionpay'
                    },
                    {
                        mask: '0000 0000 0000 0000',
                        cardtype: 'Unknown'
                    }
                ],
                dispatch: function (appended, dynamicMasked) {
                    var number = (dynamicMasked.value + appended).replace(/\D/g, '');
            
                    for (var i = 0; i < dynamicMasked.compiledMasks.length; i++) {
                        let re = new RegExp(dynamicMasked.compiledMasks[i].regex);
                        if (number.match(re) != null) {
                            return dynamicMasked.compiledMasks[i];
                        }
                    }
                }
            });
        }
    }


    return {
        init: function() {
            phone();
            currencyMask();
            percentMask();
            birthday();
            birthdayEvent();
            cpf();
            cep();
            expirationDate();
            securityCode();
            numberCard();
        }
    };
}();
    
$(function () {
    maskInputs.init();
});
